import { useQuery } from '@tanstack/react-query';
import { customFieldsQuery } from '../utils/queries';
import { fetchCustomFields } from '../api/customFieldsApi';

export const useCustomFieldQuery = () => {
  return useQuery({
    queryKey: customFieldsQuery.all,
    queryFn: async () => {
      const fields = await fetchCustomFields();
      return fields;
    },
    initialData: [],
    gcTime: 0,
  });
};
